import React, { ReactElement } from 'react'
import i18n from 'live/services/i18n'
import { Title } from '../..'
import GroupConfig from './group/GroupConfig'
import { cloneDeepGridEditorGroup } from '../../../cloneDeepFunctions'
import AssetSelector from '../AssetSelector'
import useCurves from '../../hooks/useCurves'
import Toggle from '../Toggle'
import TableModeConfigView from './TableModeConfigView'

interface Props {
    configField: string
    widgetConfig: GridConfig
    value?: Array<GridEditorGroup>
    onChange: (value: Array<GridEditorGroup>, updateQuery: boolean) => void
    changeConfig: (field: string, value: unknown, sideEffects?: Record<string, boolean>) => void
    isEditor: boolean
}

export default function GroupsEditorField(props: Props): ReactElement {

    const groups: Array<GridEditorGroup> = props?.value?.map(group => cloneDeepGridEditorGroup(group)) ?? []
    const curves = useCurves()

    const addNewGroup = (): void => {
        const newGroupId = groups.length > 0 ? groups[groups.length - 1].id + 1 : 1
        const newGroups = [
            ...groups,
            {
                id: newGroupId,
                title: '',
                isOpen: true,
                defaultTitle: 'Group ' + newGroupId,
                groupColor: '',
                channels: [],
                nColumns: 3,
                valueBold: false,
                valueFontSize: '20',
                uomBold: false,
                uomFontSize: '16',
                groupTitleFontSize: '14',
                titleFontSize: '14',
                titleBold: true
            }
        ]
        props.onChange(newGroups, false)
    }
    const removeGroup = (groupId: number, updateQuery: boolean): void => {
        const newGroups: Array<GridEditorGroup> = groups.filter(group => group?.id !== groupId)
        props.onChange(newGroups, updateQuery)
    }

    const changeGroup = (newGroup: GridEditorGroup, updateQuery: boolean): void => {
        const newGroups: Array<GridEditorGroup> = groups.map(group => ({
            ...(newGroup?.id === group?.id ? cloneDeepGridEditorGroup(newGroup) : group)
        }))
        props.onChange(newGroups, updateQuery)
    }

    return (
        <>
            {(props.isEditor ?? false) && <AssetSelector label={'Asset'} />}

            <TableModeConfigView
                tableModeConfig={props?.widgetConfig?.tableModeConfig}
                changeConfig={props.changeConfig}
                isEditor={props.isEditor}
            />

            {groups.map(group =>
                group ? (
                    <GroupConfig
                        key={group.id}
                        group={group}
                        onChangeGroup={changeGroup}
                        onRemoveGroup={removeGroup}
                        widgetConfig={props?.widgetConfig}
                        canDeleteGroup={true}
                        loadingChannels={true}
                        curves={curves}
                        isEditor={props?.isEditor}
                        isTableMode={props?.widgetConfig?.tableModeConfig?.enable}
                    />
                ) : null
            )}

            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <button
                    style={{ width: '100%', height: '36px' }}
                    className={'Add-group-btn'}
                    title={i18n('Add Group')}
                    onClick={() => {
                        addNewGroup()
                    }}
                >
                    <span>
                        <i className={'fa fa-plus'} style={{ paddingRight: '6px' }} />
                        <span className={'Add-group-title'}>{i18n('New Group')}</span>
                    </span>
                </button>
            </div>
        </>
    )
}
